import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'
// 初始化 SDK 实例
const tim = TIM.create({
  SDKAppID: 1400194712
})
// 注册 cos 
tim.registerPlugin({
  'cos-js-sdk': COSSDK
})
if (['production', 'prod'].includes(process.env.NODE_ENV)) {
  // 0 普通级别，日志量较多，接入时建议使用
  // 1 release级别，SDK 输出关键信息，生产环境时建议使用
  // 2 告警级别，SDK 只输出告警和错误级别的日志
  // 3 错误级别，SDK 只输出错误级别的日志
  // 4 无日志级别，SDK 将不打印任何日志
  tim.setLogLevel(4); // 普通级别，日志量较多，接入时建议使用
} else {
  tim.setLogLevel(4); // 普通级别，日志量较多，接入时建议使用
}
export default tim


// WEBPACK FOOTER //
// ./src/tim.js